/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithIsActiveItemRequestBuilder, WithIsActiveItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Client/{id}
 */
export interface ClientItemRequestBuilder extends BaseRequestBuilder<ClientItemRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.Client.item.item collection
     * @param isActive Unique identifier of the item
     * @returns {WithIsActiveItemRequestBuilder}
     */
     byIsActive(isActive: boolean) : WithIsActiveItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const ClientItemRequestBuilderUriTemplate = "{+baseurl}/Client/{id}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ClientItemRequestBuilderNavigationMetadata: Record<Exclude<keyof ClientItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byIsActive: {
        requestsMetadata: WithIsActiveItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["isActive"],
    },
};
/* tslint:enable */
/* eslint-enable */
